import { useEffect, useState } from 'react';
import styles from './TrendsSearchBar.module.css';
import { useGlobalContext } from '@/lib/context';
import { API } from '@/lib/helpers/http-client';
import { Input as InputText } from '../../../components/ui/input/Input';
import Image from 'next/image';
import { NavLink } from '@/components/ui';
export function TrendsSearchBar() {
    const [search, setSearch] = useState('');
    const siteUrl = process.env.SITE_URL || '';
    const { props: { countryCode } } = useGlobalContext();
    const [dropdownData, setDropdownData] = useState([]);
    const fetchData = async (inputVal: string) => {
        if (inputVal.trim() != '' && inputVal.length > 2) {
            let list = await API.post(`/api/blogSearch?searchText=${inputVal}`);
            if (list && list.data) {
                setDropdownData(list.data)
            }
        } else {
            setDropdownData([])
        }
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchData(search);
        }, 500);
        return () => clearTimeout(timer);
    }, [search]);
    return (
        <div className={`${styles.trendSearchBox} ${dropdownData.length > 0 && styles.active}`}>
            <InputText type="text" autoComplete='off' value={search} onChange={(e) => setSearch(e.target.value)} className="formControl" placeholder='Search' required={true} />
            <div className={styles.searchIcon}>
                <Image src="/assets/images/searchIcon.svg" width={16} height={17} alt="Search" />
            </div>
            <div id="myDropdown" className={styles.dropdownList}>
                <ul>
                    {dropdownData && dropdownData.map((item: { title: string, permalink: string }, index: number) => (
                        <NavLink key={index} href={`${siteUrl}/${countryCode}/trends/${item.permalink}`}><li>{item.title}</li></NavLink>
                    ))}
                </ul>
            </div>
        </div>

    )
}